// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Ygb2","tab":"Tabs_tab__swvRI","tabActive":"Tabs_tabActive__1u-xE"};